import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notificationKeys } from "../notification.keys";
import { notificationApi } from "../service";

/**
 * Admin switch-off of any user's device (idempotent on the server).
 *
 * Invalidates everything under the notification root: the admin list and stats lose the
 * device, and `devices()` too — the revoked device might be the admin's own.
 */
export function useRevokePushDevice() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) =>
      notificationApi.revokeDevice(id).then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationKeys.all });
    },
  });
}
